/**
 * Canonical provider identity shared by product code, the admin app, and
 * Convex validators. Keep this package dependency-free so every runtime can
 * consume the same tuple without crossing an application boundary.
 */
export const INTEGRATION_PROVIDER_IDS = [
  'braze',
  'brevo',
  'clerk',
  'customerio',
  'figma',
  'framer',
  'slack',
  'hubspot',
  'typeform',
  'klaviyo',
  'iterable',
  'postmark',
  'onesignal',
  'mailgun',
  'sendgrid',
  'mailjet',
  'mailchimp',
  'stripe',
  'stytch',
  'supabase',
  'workos',
  'shopify',
  'revenuecat',
] as const

export type IntegrationProvider = (typeof INTEGRATION_PROVIDER_IDS)[number]

const INTEGRATION_PROVIDER_ID_SET: ReadonlySet<string> = new Set(
  INTEGRATION_PROVIDER_IDS
)

export function isIntegrationProvider(
  value: string
): value is IntegrationProvider {
  return INTEGRATION_PROVIDER_ID_SET.has(value)
}
